import { forEach, reduce, isString, has, isEmpty } from 'lodash';
import { POST, GET } from '../constants/requestMethods';
import { ROUTE_OAUTH_1A_AUTH } from '../constants/pathnames';
import { getCurrentUtcTime } from '../lib/DateUtils';
import { CORS_URL } from '../constants/config';
import { getCorsCompatibleURL } from '../lib/URLUtils';

const OAuth = require('./utils/oauth');

const REDIRECT_URI = window.location.protocol + '//' + window.location.host + ROUTE_OAUTH_1A_AUTH;
const REQUEST_URL_PARAM_PREFIX = 'oauth1a.request_url_param.';
const AUTH_URL_PARAM_PREFIX = 'oauth1a.auth_url_param.';

function authenticate(fn, credInfo) {
  const oauth_secrets = {};
  window.HandlePopupResult = function (authResponse, error) {
    delete window.HandlePopupResult;

    let accessError = null;

    if (error) {
      accessError = error;
    } else if (has(authResponse, 'error')) {
      accessError = {
        code: authResponse.error,
        description: has(authResponse, 'error_description')
          ? authResponse.error_description
          : authResponse.error,
      };
    } else if (has(authResponse, 'access_token')) {
      fn({ ...authResponse, authorizedAt: getCurrentUtcTime() });
    } else if (has(authResponse, 'oauth_token')) {
      const oauth_verifier = has(authResponse, 'oauth_verifier')
        ? authResponse.oauth_verifier
        : null;
      const tokenSecret = oauth_secrets[authResponse.oauth_token];
      //const tokenURL = evaluateMacros(credInfo['oauth1a.token_url'], credInfo);
      oa.getOAuthAccessToken(
        authResponse.oauth_token,
        tokenSecret,
        oauth_verifier,
        {},
        function (error, oAuthAccessToken, oAuthAccessTokenSecret, results) {
          if (error) {
            fn(null, {
              message: 'Error occured while getting access token',
              error: error,
            });
            return;
          }

          fn({
            access_token: oAuthAccessToken,
            oauth_token_secret: oAuthAccessTokenSecret,
            authorizedAt: getCurrentUtcTime(),
          });
        },
      );
    }
    if (accessError) {
      fn(null, accessError);
    }
  };

  const credReqUrl = evaluateMacros(credInfo['oauth1a.request_url'], credInfo);

  const requestUrlParam = getCorsCompatibleURL(credReqUrl);

  const authorizeUrlParam = evaluateMacros(credInfo['oauth1a.auth_url'], credInfo);

  const credAccessUrl = evaluateMacros(credInfo['oauth1a.token_url'], credInfo);

  const accessUrlParam = getCorsCompatibleURL(credAccessUrl);

  const consumerKey = evaluateMacros(
    credInfo['oauth1a.request_url_param.oauth_consumer_key'],
    credInfo,
  );

  const secretKey = evaluateMacros(
    credInfo['oauth1a.request_url_param.oauth_consumer_secret'],
    credInfo,
  );

  const oa = getOauthObject(requestUrlParam, accessUrlParam, consumerKey, secretKey);

  // TODO: if this statement doesn't have a side-effect, it should be removed
  // eslint-disable-next-line
  const requestHeader = oa.authHeader(
    requestUrlParam + `?oauth_callack=${REDIRECT_URI}`,
    null,
    null,
    'POST',
  );

  let reqUrlParams = getParamsFromCredInfo(credInfo, REQUEST_URL_PARAM_PREFIX, POST);

  if (has(reqUrlParams, 'oauth_consumer_key')) {
    delete reqUrlParams['oauth_consumer_key'];
  }

  if (has(reqUrlParams, 'oauth_consumer_secret')) {
    delete reqUrlParams['oauth_consumer_secret'];
  }

  //const oauth = getOauthSignature(CONSUMER_KEY, CONSUMER_SECRET);

  oa.getOAuthRequestToken(reqUrlParams, function (error, oAuthToken, oAuthTokenSecret, results) {
    oauth_secrets[oAuthToken] = oAuthTokenSecret;
    const authorizeUrl = authorizeUrlParam;
    const authUrlParams = getParamsFromCredInfo(credInfo, AUTH_URL_PARAM_PREFIX, GET, {
      oauth_token: oAuthToken,
    });

    window.open(
      authorizeUrl + authUrlParams,
      'Authorization',
      'top=300,left=250,height=600,width=600',
    );
  });
}

function getParamsFromCredInfo(credInfo, paramPrefix, method = POST, extraParams = null) {
  let params = {};
  if (extraParams) {
    params = { ...params, ...extraParams };
  }

  forEach(credInfo, (value, key) => {
    if (!key.startsWith(paramPrefix)) {
      //Strip out oauth_consumer_key is necessary for oauth signature, but it should not be part of request payload in request_token step
      return;
    }

    const paramName = key.substring(paramPrefix.length);
    const paramValue = evaluateMacros(value, credInfo);

    params[paramName] =
      paramName !== 'oauth_callback' ? encodeURIComponent(paramValue) : paramValue;
  });

  if (method === GET && !isEmpty(params)) {
    let paramArray = reduce(
      params,
      (acc, val, key) => {
        acc.push(`${key}=${val}`);
        return acc;
      },
      [],
    );
    return `?${paramArray.join('&')}`;
  }
  return params;
}

function evaluateMacros(value, data) {
  if (isString(value)) {
    // evaluate macros in the param value
    const macros = value.match(/\$\{([\w.]+)\}/g);
    return reduce(
      macros,
      (acc, macro) => {
        const macroParamName = macro.slice(2, -1);
        return acc.replace(macro, data[macroParamName]);
      },
      value,
    );
  }

  return value;
}

function getOauthObject(requestUrl, accessUrl, consumerKey, consumerSecret) {
  console.log(requestUrl);
  console.log(accessUrl);
  const oa = new OAuth.OAuth(
    requestUrl,
    accessUrl,
    consumerKey,
    consumerSecret,
    '1.0',
    REDIRECT_URI,
    'HMAC-SHA1',
    CORS_URL, //needs fully formatted CORS URL (  public_url + /cors/)
  );

  return oa;
  // return OAuth({
  //   consumer: {
  //     key: consumerKey,
  //     secret: consumerSecret
  //   },
  //   signature_method: 'HMAC-SHA1',
  //   hash_function(base_string, key) {
  //     return crypto
  //       .createHmac('sha1', key)
  //       .update(base_string)
  //       .digest('base64');
  //   }
  // });
}

export default { authenticate };
